import { BigNumberish } from 'ethers'
import { Vault } from '@/constants/contract/contractTypes'

export const feeCall = (contract: Vault) => {
  return contract.fee()
}

export interface DepositCallParams {
  contract: Vault
  tokenAddress: string
  amount: BigNumberish
  receiverAddress: string
  fee: BigNumberish
}

export interface WithdrawCallParams {
  contract: Vault
  tokenAddress: string
  receiverAddress: string
  amount: BigNumberish
  txid: string
  v: string[]
  r: string[]
  s: string[]
}

export const depositCall = async ({ contract, tokenAddress, amount, receiverAddress, fee }: DepositCallParams) => {
  const tx = await contract.deposit(tokenAddress, amount, receiverAddress, { value: fee })
  return tx.wait(1)
}

export const withdrawCall = async ({
  contract,
  tokenAddress,
  receiverAddress,
  amount,
  txid,
  v,
  r,
  s,
}: WithdrawCallParams) => {
  const tx = await contract.withdraw(tokenAddress, receiverAddress, amount, txid, v, r, s)
  return tx.wait(1)
}
